import { combineReducers } from "@reduxjs/toolkit";
import stockCountReducer from "./stockCount/stockCount.slice";
// auth
import loginReducer from "./auth/login.slice";
import createVerifyRoleLogReducer from "./auth/createVerifyRoleLog.slice";
import createOrUpdateNewAlldernowUserReducer from "./auth/createOrUpdateNewAlldernowUser.slice";
import getUserInfoReducer from "./auth/getUserInfo.slice";
import getMenuReducer from "./auth/getMenu.slice";
// master
import getAllMstPrefixReducer from "./master/getAllMstPrefix.slice";
import getAllMstSexReducer from "./master/getAllMstSex.slice";
import getAllMstMaritalStatusReducer from "./master/getAllMstMaritalStatus.slice";
import getAllMstMilitaryStatusReducer from "./master/getAllMstMilitaryStatus.slice";
import getAllMstRelationshipReducer from "./master/getAllMstRelationship.slice";
import getAllMstEmployeeTypeReducer from "./master/getAllMstEmployeeType.slice";
import getAllMstDepartmentReducer from "./master/getAllMstDepartment.slice";
import getAllMstPositionReducer from "./master/getAllMstPosition.slice";
import getAllMstBankReducer from "./master/getAllMstBank.slice";
import getAllMstBankAccountTypeReducer from "./master/getAllMstBankAccountType.slice";
import getAllMstEmployeeDocReducer from "./master/getAllMstEmployeeDoc.slice";
import getAllMstBranchReducer from "./master/getAllMstBranch.slice";
import getAllMstBusinessTypeReducer from "./master/getAllMstBusinessType.slice";
import getAllMstBusinessCategoryReducer from "./master/getAllMstBusinessCategory.slice";
import getAllMstCompanyPrefixReducer from "./master/getAllMstCompanyPrefix.slice";
import getAllMstPaymentMethodReducer from "./master/getAllMstPaymentMethod.slice";
import getAllMstPaymentTermReducer from "./master/getAllMstPaymentTerm.slice";
import getAllMstSupplierDocReducer from "./master/getAllMstSupplierDoc.slice";
import getAllMstNewAlldernowRoleReducer from "./master/getAllMstNewAlldernowRole.slice";
import getAllMstPaymentTypeReducer from "./master/getAllMstPaymentType.slice";
import getAllMstDiscountTypeReducer from "./master/getAllMstDiscountType.slice";
import getAllMstPriceCategoryReducer from "./master/getAllMstPriceCategory.slice";
import getAllMstVatReducer from "./master/getAllMstVat.slice";
import getAllWarehouseReducer from "./master/getAllWarehouse.slice";
import getAllMasterBrandReducer from "./master/getAllMasterBrand.slice";
import getAllMasterMainCategoryReducer from "./master/getAllMasterMainCategory.slice";
import getAllMstNewItemPrColReducer from "./master/getAllMstNewItemPrCol.slice";
import getAllMstOfficeSectionReducer from "./master/getAllMstOfficeSection.slice";
import getFirstMstCompanyReducer from "./master/getFirstMstCompany.slice";
import getFirstMstMartReducer from "./master/getFirstMstMart.slice";
import getAllMstAddCostReducer from "./master/getAllMstAddCost.slice";
import getAllMstAddCostUnitReducer from "./master/getAllMstAddCostUnit.slice";
import getAllMstNewItemExpenseColReducer from "./master/getAllMstNewItemExpenseCol.slice";
import getAllMstWithholdingTaxReducer from "./master/getAllMstWithholdingTax.slice";
import getAllMstExpenseTypeReducer from "./master/getAllMstExpenseType.slice";
import getAllMstBrandReducer from "./master/getAllMstBrand.slice";
// logic
import createNewAlldernowEmpReducer from "./logic/createNewAlldernowEmp.slice";
import updateNewAlldernowEmpReducer from "./logic/updateNewAlldernowEmp.slice";
import getAllNewAlldernowEmpReducer from "./logic/getAllNewAlldernowEmp.slice";
import getNewAlldernowEmpByIdReducer from "./logic/getNewAlldernowEmpById.slice";
import createSupplierInformationReducer from "./logic/createSupplierInformation.slice";
import updateSupplierInformationReducer from "./logic/updateSupplierInformation.slice";
import getAllSupplierInformationReducer from "./logic/getAllSupplierInformation.slice";
import getSupplierInformationByIdReducer from "./logic/getSupplierInformationById.slice";
import createGroupOfSupplierReducer from "./logic/createGroupOfSupplier.slice";
import updateGroupOfSupplierReducer from "./logic/updateGroupOfSupplier.slice";
import getGroupOfSupplierByIdReducer from "./logic/getGroupOfSupplierById.slice";
import getAllGroupOfSupplierReducer from "./logic/getAllGroupOfSupplier.slice";
import getAllProductPriceReducer from "./logic/getAllProductPrice.slice";
import getProductPriceByIdReducer from "./logic/getProductPriceById.slice";
import createNewPurchaseReqReducer from "./logic/createNewPurchaseReq.slice";
import updateNewPurchaseReqReducer from "./logic/updateNewPurchaseReq.slice";
import getAllNewPurchaseReqReducer from "./logic/getAllNewPurchaseReq.slice";
import getNewPurchaseReqByIdReducer from "./logic/getNewPurchaseReqById.slice";
import genNewPurchaseReqDocNumberReducer from "./logic/genNewPurchaseReqDocNumber.slice";
import createNewPurchaseOrderReducer from "./logic/createNewPurchaseOrder.slice";
import updateNewPurchaseOrderReducer from "./logic/updateNewPurchaseOrder.slice";
import getAllNewPurchaseOrderReducer from "./logic/getAllNewPurchaseOrder.slice";
import getNewPurchaseOrderByIdReducer from "./logic/getNewPurchaseOrderById.slice";
import genNewPurchaseOrderDocNumberReducer from "./logic/genNewPurchaseOrderDocNumber.slice";
import getAllNewPoSplitReducer from "./logic/getAllNewPoSplit.slice";
import getNewPoSplitByIdReducer from "./logic/getNewPoSplitById.slice";
import genNewGrDocNumberReducer from "./logic/genNewGrDocNumber.slice";
import createNewGrReducer from "./logic/createNewGr.slice";
import getAllNewGrReducer from "./logic/getAllNewGr.slice";
import getNewGrByIdReducer from "./logic/getNewGrById.slice";
import updateNewGrReducer from "./logic/updateNewGr.slice";
import getHQAddressByDateReducer from "./logic/getHQAddressByDate.slice";
import createExpenseReducer from "./logic/createExpense.slice";
import updateExpenseReducer from "./logic/updateExpense.slice";
import getAllExpenseReducer from "./logic/getAllExpense.slice";
import getExpenseByIdReducer from "./logic/getExpenseById.slice";
import genExpenseDocNumberReducer from "./logic/genExpenseDocNumber.slice";
// Partner
import getAllPartnerInfoReducer from "./partner/getAllPartnerInfo.slice";
import getPartnerInfoByIdReducer from "./partner/getPartnerInfoById.slice";
import updateStatusPartnerReducer from "./partner/updateStatusPartner.slice";
import getPartnerBankByIdReducer from "./partner/getPartnerBankById.slice";
import getPartnerDocByIdReducer from "./partner/getPartnerDocById.slice";
import getPartnerProductByIdReducer from "./partner/getPartnerProductById.slice";
import getPartnerCommentByIdReducer from "./partner/getPartnerCommentById.slice";
import createCommentPartnerReducer from "./partner/createCommentPartner.slice";
import updateStatusBankPartnerReducer from "./partner/updateStatusBankPartner.slice";
import updateStatusDocPartnerReducer from "./partner/updateStatusDocPartner.slice";
import getAllProvinceReducer from "./master/getAllProvince.slice";
import getAddressCountriesReducer from "./master/getAddressCountries.slice";
import getAddressProvinceReducer from "./master/getAddressProvince.slice";
import getAddressDistrictReducer from "./master/getAddressDistrict.slice";
import getAddressSubdistrictReducer from "./master/getAddressSubdistrict.slice";
import getAddressLaoProvinceReducer from "./master/getAddressLaoProvince.slice";
import getAddressLaoDistrictReducer from "./master/getAddressLaoDistrict.slice";
import getAddressLaoVillageReducer from "./master/getAddressLaoVillage.slice";
import getAllDistrictReducer from "./master/getAllDistrict.slice";
import getAllDistrictSubReducer from "./master/getAllDistrictSub.slice";
import getAllSubDistrictReducer from "./master/getAllSubDistrict.slice";
import getAllSubDistrictSubReducer from "./master/getAllSubDistrictSub.slice";
import getAllMstTypeDocumentReducer from "./master/getAllMstTypeDocument.slice";
//Product
import getAllProductInfoReducer from "./product/getAllProductInfo.slice";
import getPresentationInfoByIdReducer from "./product/getPresentationInfoById.slice";
import updateStatusProductReducer from "./product/updateStatusProduct.slice";
import getProductInfoByIdReducer from "./product/getProductInfoById.slice";
import getProductTypeReducer from "./product/getProductType.slice";
import getCategoryReducer from "./product/getCategory.slice";
import getSubCategoryReducer from "./product/getSubCategory.slice";
import createCommentProductReducer from "./product/createCommentProduct.slice";
import getEvidenceTypeReducer from "./product/getEvidenceType.slice";
import getAllMstUnitReducer from "./product/getAllMstUnit.slice";
import getAllMstUnitWeightReducer from "./product/getAllMstUnitWeight.slice";
import getAllDimensionReducer from "./product/getAllDimension.slice";
import getAllProductTypeFileReducer from "./product/getAllProductTypeFile.slice";
// contract
import getAllDataContractReducer from "./contract/getAllDataContract.slice";
import getAllDataContractExcelReducer from "./contract/getAllDataContractExcel.slice";
import getAllMstBusinessReducer from "./master/getAllMstBusiness.slice";
import getContractBankByIdReducer from "./contract/getContractBankById.slice";
import getContractProductInfoReducer from "./contract/getContractProductInfo.slice";
import getAllBranchByPositionReducer from "./contract/getAllBranchByPosition.slice";
import getAllBranchByAdPointReducer from "./contract/getAllBranchByAdPoint.slice";
import createContractNewReducer from "./contract/createContractNew.slice";
import updateContractReducer from "./contract/updateContract.slice";
import getContractByIdReducer from "./contract/getContractById.slice";
import getContractProductByIdReducer from "./contract/getContractProductById.slice";
import getContractPlacementByIdReducer from "./contract/getContractPlacementById.slice";
import getContractAdsByIdReducer from "./contract/getContractAdsById.slice";
import updateContractStatusReducer from "./contract/updateContractStatus.slice";
import uploadContractFileDocReducer from "./contract/uploadContractFileDoc.slice";
import updateApproveFileReducer from "./contract/updateApproveFile.slice";
import getContractFileByIdReducer from "./contract/getContractFileById.slice";
import updateContractFileReducer from "./contract/updateContractFile.slice";
import updateContractDelReducer from "./contract/updateContractDel.slice";
import getContractBankInfoReducer from "./contract/getContractBankInfo.slice";
import getContractBillingInfoReducer from "./contract/getContractBillingInfo.slice";
// quotation
import getAllDataQuotationReducer from "./quotation/getAllDataQuotation.slice";
import getAllDataQuotationExcelReducer from "./quotation/getAllDataQuotationExcel.slice";
import updateQuotationDelReducer from "./quotation/updateQuotationDel.slice";
import createQuotationReducer from "./quotation/createQuotation.slice";
import updateQuotationReducer from "./quotation/updateQuotation.slice";
import updateQuotationFileReducer from "./quotation/updateQuotationFile.slice";
import getQuotationNewByIdReducer from "./quotation/getQuotationNewById.slice";
import getQuotationFileByIdReducer from "./quotation/getQuotationFileById.slice";
import getQuotationDetailByIdReducer from "./quotation/getQuotationDetailById.slice";
import updateQuotationStatusReducer from "./quotation/updateQuotationStatus.slice";
import getQuotContractInfoByIdReducer from "./quotation/getQuotContractInfoById.slice";
// bill
import billingReducer from "./billing/billing.slice";
import getBillingByIDReducer from "./billing/getBillingByID.slice";
import createBillingReducer from "./billing/createBilling.slice";
import uploadBillingReducer from "./billing/uploadBilling.slice";
import updateBillingReducer from "./billing/updateBilling.slice";
import billingQuotationListReducer from "./billing/billingQuotationList.slice";
import getQuotationByIDReducer from "./billing/getQuotationByID.slice";
import updateBillingCancelReducer from "./billing/updateBillingCancel.slice";
//invoice
import invoiceReducer from "./invoice/invoice.slice";
import getInvoiceByIDReducer from "./invoice/getInvoiceByID.slice";
import createInvoiceReducer from "./invoice/createInvoice.slice";
import updateInvoiceReducer from "./invoice/updateInvoice.slice";
import uploadInvoiceReducer from "./invoice/uploadInvoice.slice";
import createbybillingReducer from "./invoice/createbybilling.slice";
import updateInvoiceCancelReducer from "./invoice/updateInvoiceCancel.slice";
// report
import getAllReportPurchaseProductPoItemReducer from "./report/getAllReportPurchaseProductPoItem.slice";
import getAllReportPurchaseSupplierReducer from "./report/getAllReportPurchaseSupplier.slice";
import getAllReportPurchaseOrderReducer from "./report/getAllReportPurchaseOrder.slice";
import getAllReportReceiveProductGrItemReducer from "./report/getAllReportReceiveProductGrItem.slice";
import getAllMapsReducer from "./report/getAllMaps.slice";
import getAllAppointmentReducer from "./report/getAllAppointment.slice";
// setting
import allBranchReducer from "./manage/allBranch.slice";
import allBranchByIDReducer from "./manage/allBranchByID.slice";
import createBranchReducer from "./manage/createBranch.slice";
import updateBranchReducer from "./manage/updateBranch.slice";
import deleteBranchReducer from "./manage/deleteBranch.slice";
import allPositionReducer from "./manage/allPosition.slice";
import createPositionReducer from "./manage/createPosition.slice";
import updatePositionReducer from "./manage/updatePosition.slice";
import deletePositionReducer from "./manage/deletePosition.slice";
import allAdpointReducer from "./manage/allAdpoint.slice";
import createAdpointReducer from "./manage/createAdpoint.slice";
import updateAdpointReducer from "./manage/updateAdpoint.slice";
import deleteAdpointReducer from "./manage/deleteAdpoint.slice";
import mstPromoTypeReducer from "./manage/mstPromoType.slice";
import allPromotionReducer from "./manage/allPromotion.slice";
import allPromotionByIDReducer from "./manage/allPromotionByID.slice";
import createPromotionReducer from "./manage/createPromotion.slice";
import updatePromotionReducer from "./manage/updatePromotion.slice";
import deletePromotionReducer from "./manage/deletePromotion.slice";
import allBrandReducer from "./manage/allBrand.slice";
import createBrandReducer from "./manage/createBrand.slice";
import updateBrandReducer from "./manage/updateBrand.slice";
import deleteBrandReducer from "./manage/deleteBrand.slice";
import getDataclbookOneReducer from "./manage/getDataclbookOne.slice";
import getDataclbookReducer from "./manage/getDataclbook.slice";
import createclbookReducer from "./manage/createclbook.slice";
import updateclbookReducer from "./manage/updateclbook.slice";
import updateStatusclbookReducer from "./manage/updateStatusclbook.slice";
import deleteclbookReducer from "./manage/deleteclbook.slice";
import copyclbookReducer from "./manage/copyclbook.slice";
import allCatalogReducer from "./manage/allCatalog.slice";
import getProductReducer from "./manage/getProduct.slice";
import getCatalogByIdReducer from "./manage/getCatalogById.slice";
import updateStatusCatalogReducer from "./manage/updateStatusCatalog.slice";
import updateStatusNewReducer from "./manage/updateStatusNew.slice";
import updateStatusRecomReducer from "./manage/updateStatusRecom.slice";
import getPromotionReducer from "./manage/getPromotion.slice";
import createCatalogReducer from "./manage/createCatalog.slice";
import updateCatalogReducer from "./manage/updateCatalog.slice";
import deleteCatalogReducer from "./manage/deleteCatalog.slice";
import deleteOpenCatalogReducer from "./manage/deleteOpenCatalog.slice";
import updateDetailCatalogReducer from "./manage/updateDetailCatalog.slice";
import mstSysRoleReducer from "./manage/mstSysRole.slice";
import allSetUserReducer from "./manage/allSetUser.slice";
import createSetUserReducer from "./manage/createSetUser.slice";
import updateSetUserReducer from "./manage/updateSetUser.slice";
import allSetUserByIDReducer from "./manage/allSetUserByID.slice";
import getAllMstTypeProductReducer from "./setting/getAllMstTypeProduct.slice";
import createMstTypeProductReducer from "./setting/createMstTypeProduct.slice";
import updateMstTypeProductReducer from "./setting/updateMstTypeProduct.slice";
import deleteMstTypeProductReducer from "./setting/deleteMstTypeProduct.slice";
import getAllMstCateProductReducer from "./setting/getAllMstCateProduct.slice";
import createMstCateProductReducer from "./setting/createMstCateProduct.slice";
import updateMstCateProductReducer from "./setting/updateMstCateProduct.slice";
import deleteMstCateProductReducer from "./setting/deleteMstCateProduct.slice";
import getAllMstSubCateProductReducer from "./setting/getAllMstSubCateProduct.slice";
import createMstSubCateProductReducer from "./setting/createMstSubCateProduct.slice";
import updateMstSubCateProductReducer from "./setting/updateMstSubCateProduct.slice";
import deleteMstSubCateProductReducer from "./setting/deleteMstSubCateProduct.slice";
import getDataShopReducer from "./manage/getDataShop.slice";
import createShopReducer from "./manage/createShop.slice";
import updateShopReducer from "./manage/updateShop.slice";
import updateStatusShopReducer from "./manage/updateStatusShop.slice";
import uploadShopReducer from "./manage/uploadShop.slice";
import deleteShopReducer from "./manage/deleteShop.slice";
import getSaleuserReducer from "./manage/getSaleuser.slice";
import getDataShopBranchReducer from "./manage/getDataShopBranch.slice";
import updateStatusShBranchReducer from "./manage/updateStatusShBranch.slice";
import updateShBranchReducer from "./manage/updateShBranch.slice";
import createShBranchReducer from "./manage/createShBranch.slice";
import deleteShBranchReducer from "./manage/deleteShBranch.slice";
import getDataShopBranchByIdReducer from "./manage/getDataShopBranchById.slice";
import getDataShopByIdReducer from "./manage/getDataShopById.slice";
import shopSpecialPriceReducer from "./manage/shopSpecialPrice.slice";
//reservation
import getAllDataRsreserveReducer from "./reservation/getAllDataRsreserve.slice";
import updateStatusSalesReducer from "./reservation/updateStatusSales.slice";
import updateStatusReserveReducer from "./reservation/updateStatusReserve.slice";
import getDataRsreserveByIdReducer from "./reservation/getDataRsreserveById.slice";
import getDataCatalogByIdReducer from "./reservation/getDataCatalogById.slice";
import updateRsreserveReducer from "./reservation/updateRsreserve.slice";
import deleteRsreserveReducer from "./reservation/deleteRsreserve.slice";
import getDataAllCatalogReducer from "./reservation/getDataAllCatalog.slice";
import createRsreserveReducer from "./reservation/createRsreserve.slice";
import createReservationReducer from "./reservation/createReservation.slice";
import getReservationCreateShopReducer from "./reservation/getReservationCreateShop.slice";
import datalistProductReducer from "./product/datalistProduct.slice";
import uploadProductReducer from "./product/uploadProduct.slice";
import getProductDetailReducer from "./product/getProductDetail.slice";
import getAllChannelOfflineReducer from "./product/getAllChannelOffline.slice";
import getAllChannelOnlineReducer from "./product/getAllChannelOnline.slice";
import getAllProductFileTypeReducer from "./product/getAllProductFileType.slice";
import updateProductReducer from "./product/updateProduct.slice";
import allShopReducer from "./manage/allShop.slice";
import allShopBranchReducer from "./manage/allShopBranch.slice";
import getDataVisitReducer from "./manage/getDataVisit.slice";
import getShopReducer from "./manage/getShop.slice";
import getObjectiveReducer from "./manage/getObjective.slice";
import createVisitReducer from "./manage/createVisit.slice";
import updateStatusVisitReducer from "./manage/updateStatusVisit.slice";
import updateVisitReducer from "./manage/updateVisit.slice";
import detailVisitReducer from "./manage/detailVisit.slice";
import uploadVisitReducer from "./manage/uploadVisit.slice";
import getDataVisitTotalReducer from "./manage/getDataVisitTotal.slice";
import getMstBrandCateReducer from "./master/getMstBrandCate.slice";
import getReportBrandReducer from "./report/getReportBrand.slice";
import getReportProductReducer from "./report/getReportProduct.slice";
import getReportSaleskuReducer from "./report/getReportSalesku.slice";
import getReportSaleShopReducer from "./report/getReportSaleShop.slice";
import getReportSaleShopDetailReducer from "./report/getReportSaleShopDetail.slice";
import getReportChartPartnerReducer from "./report/getReportChartPartner.slice";
import getReportChartBranchReducer from "./report/getReportChartBranch.slice";
import getReportChartBranchDayReducer from "./report/getReportChartBranchDay.slice";
import getReportChartSkuReducer from "./report/getReportChartSku.slice";
import getReportBrandDetailReducer from "./report/getReportBrandDetail.slice";
import getReportChartReserveReducer from "./report/getReportChartReserve.slice";
import getReportSaleSkuListsoldReducer from "./report/getReportSaleSkuListsold.slice";
import getReportSaleSkuListsnewReducer from "./report/getReportSaleSkuListsnew.slice";
import getReportChartReserveDayReducer from "./report/getReportChartReserveDay.slice";
import getReportChartSkuDayReducer from "./report/getReportChartSkuDay.slice";
import getReportChartPartnerDayReducer from "./report/getReportChartPartnerDay.slice";
import getReportSaleVisitAndReserveReducer from "./report/getReportSaleVisitAndReserve.slice";
import getReportSaleVisitAndReserveBySaleReducer from "./report/getReportSaleVisitAndReserveBySale.slice";
import updateRsreserveStockReducer from "./reservation/updateRsreserveStock.slice";
import getCatalogSummaryReducer from "./master/getCatalogSummary.slice";
import getReportSaleIntendantBranchReducer from "./report/getReportSaleIntendantBranch.slice";
import getReportBrandallReducer from "./report/getReportBrandall.slice";
import getReportBrandallSummaryReducer from "./report/getReportBrandallSummary.slice";
import getReportVisitSaleMonthReducer from "./report/getReportVisitSaleMonth.slice.js";
import getReportVisitSaleMonthListReducer from "./report/getReportVisitSaleMonthList.slice.js";
import getReportReserveProductSummaryReducer from "./report/getReportReserveProductSummary.slice";
import getReportReservationPerformanceMonthlyReducer from "./report/getReportReservationPerformanceMonthly.slice";
import getReportReservationWorkTrackingReducer from "./report/getReportReservationWorkTracking.slice";
import getReportSkuActualDeliveryMonthlyReducer from "./report/getReportSkuActualDeliveryMonthly.slice";
import getReportProductNotReadyDeliveryDatalistReducer from "./report/getReportProductNotReadyDeliveryDatalist.slice";
import getReportProductNotReadyDeliveryWidgetReducer from "./report/getReportProductNotReadyDeliveryWidget.slice";
import getReportShippingCostAuditReducer from "./report/getReportShippingCostAudit.slice";
import getReportPurchasePendingConfirmReducer from "./report/getReportPurchasePendingConfirm.slice";
import updateStatusContinueReducer from "./product/updateStatusContinue.slice.js";
import getPermissionReducer from "./permission/getPermission.slice";
import deletePermissionReducer from "./permission/deletePermission.slice";
import getPermissionMenusReducer from "./permission/getPermissionMenus.slice";
import getPermissionDetailReducer from "./permission/getPermissionDetail.slice";
import createPermissionReducer from "./permission/createPermission.slice";
import updatePermissionReducer from "./permission/updatePermission.slice";
import updatePermissionStatusReducer from "./permission/updatePermissionStatus.slice";
//import invoice
import getAllImportInvoiceMtReducer from "./import_invoice/getAllImportInvoiceMt.slice";
import uploadImportFileInvMtReducer from "./import_invoice/uploadImportFileInvMt.slice";
import confirmImportInvMtReducer from "./import_invoice/confirmImportInvMt.slice";
import getAllImportInvoiceTtReducer from "./import_invoice/getAllImportInvoiceTt.slice";
import uploadImportFileInvTtReducer from "./import_invoice/uploadImportFileInvTt.slice";
import confirmImportInvTtReducer from "./import_invoice/confirmImportInvTt.slice";
//import product
import getAllImportProductMtReducer from "./import_product/getAllImportProductMt.slice";
import uploadFileProductMtReducer from "./import_product/uploadFileProductMt.slice";
import confirmProductMtReducer from "./import_product/confirmProductMt.slice";
import getAllImportProductTtReducer from "./import_product/getAllImportProductTt.slice";
import uploadFileProductTtReducer from "./import_product/uploadFileProductTt.slice";
import confirmProductTtReducer from "./import_product/confirmProductTt.slice";
//report invoice
import getAllReportInvoiceMtReducer from "./report_invoice/getAllReportInvoiceMt.slice";
import getAllReportInvoiceTtReducer from "./report_invoice/getAllReportInvoiceTt.slice";
//report product
import getAllReportProductMtReducer from "./report_product/getAllReportProductMt.slice";
import getAllReportProductTtReducer from "./report_product/getAllReportProductTt.slice";
// Data synchronization
import syncShopReducer from "./syncdata/syncShop.slice";
import syncShopBranchReducer from "./syncdata/syncShopBranch.slice";
import syncProductTypeReducer from "./syncdata/syncProductType.slice";
import syncProductReducer from "./syncdata/syncProduct.slice";
import syncProductCategoryReducer from "./syncdata/syncProductCategory.slice";
import syncProductSubCategoryReducer from "./syncdata/syncProductSubCategory.slice";
import syncBrandReducer from "./syncdata/syncBrand.slice";
import getProfileReducer from "./profile/getProfile.slice";
import updateProfileReducer from "./profile/updateProfile.slice";
import changeProfilePasswordReducer from "./profile/changeProfilePassword.slice";
var appReducer = combineReducers({
    stockCountReducer: stockCountReducer,
    getProfileReducer: getProfileReducer,
    updateProfileReducer: updateProfileReducer,
    changeProfilePasswordReducer: changeProfilePasswordReducer,
    syncShopReducer: syncShopReducer,
    syncShopBranchReducer: syncShopBranchReducer,
    syncProductTypeReducer: syncProductTypeReducer,
    syncProductReducer: syncProductReducer,
    syncProductCategoryReducer: syncProductCategoryReducer,
    syncProductSubCategoryReducer: syncProductSubCategoryReducer,
    syncBrandReducer: syncBrandReducer,
    loginReducer: loginReducer,
    createVerifyRoleLogReducer: createVerifyRoleLogReducer,
    createOrUpdateNewAlldernowUserReducer: createOrUpdateNewAlldernowUserReducer,
    getUserInfoReducer: getUserInfoReducer,
    getMenuReducer: getMenuReducer,
    getAllMstPrefixReducer: getAllMstPrefixReducer,
    getAllMstSexReducer: getAllMstSexReducer,
    getAllMstMaritalStatusReducer: getAllMstMaritalStatusReducer,
    getAllMstMilitaryStatusReducer: getAllMstMilitaryStatusReducer,
    getAllMstRelationshipReducer: getAllMstRelationshipReducer,
    getAllMstEmployeeTypeReducer: getAllMstEmployeeTypeReducer,
    getAllMstDepartmentReducer: getAllMstDepartmentReducer,
    getAllMstPositionReducer: getAllMstPositionReducer,
    getAllMstBankReducer: getAllMstBankReducer,
    getAllMstBankAccountTypeReducer: getAllMstBankAccountTypeReducer,
    getAllMstEmployeeDocReducer: getAllMstEmployeeDocReducer,
    getAllMstBranchReducer: getAllMstBranchReducer,
    getAllMstBusinessTypeReducer: getAllMstBusinessTypeReducer,
    getAllMstBusinessCategoryReducer: getAllMstBusinessCategoryReducer,
    getAllMstCompanyPrefixReducer: getAllMstCompanyPrefixReducer,
    getAllMstPaymentMethodReducer: getAllMstPaymentMethodReducer,
    getAllMstPaymentTermReducer: getAllMstPaymentTermReducer,
    getAllMstSupplierDocReducer: getAllMstSupplierDocReducer,
    getAllMstNewAlldernowRoleReducer: getAllMstNewAlldernowRoleReducer,
    getAllMstPaymentTypeReducer: getAllMstPaymentTypeReducer,
    getAllMstDiscountTypeReducer: getAllMstDiscountTypeReducer,
    getAllMstPriceCategoryReducer: getAllMstPriceCategoryReducer,
    getAllMstVatReducer: getAllMstVatReducer,
    getAllWarehouseReducer: getAllWarehouseReducer,
    getAllMasterBrandReducer: getAllMasterBrandReducer,
    getAllMasterMainCategoryReducer: getAllMasterMainCategoryReducer,
    getAllMstNewItemPrColReducer: getAllMstNewItemPrColReducer,
    getAllMstOfficeSectionReducer: getAllMstOfficeSectionReducer,
    getFirstMstCompanyReducer: getFirstMstCompanyReducer,
    getFirstMstMartReducer: getFirstMstMartReducer,
    getAllMstAddCostReducer: getAllMstAddCostReducer,
    getAllMstAddCostUnitReducer: getAllMstAddCostUnitReducer,
    getAllMstNewItemExpenseColReducer: getAllMstNewItemExpenseColReducer,
    getAllMstWithholdingTaxReducer: getAllMstWithholdingTaxReducer,
    getAllMstExpenseTypeReducer: getAllMstExpenseTypeReducer,
    createNewAlldernowEmpReducer: createNewAlldernowEmpReducer,
    updateNewAlldernowEmpReducer: updateNewAlldernowEmpReducer,
    getAllNewAlldernowEmpReducer: getAllNewAlldernowEmpReducer,
    getNewAlldernowEmpByIdReducer: getNewAlldernowEmpByIdReducer,
    createSupplierInformationReducer: createSupplierInformationReducer,
    updateSupplierInformationReducer: updateSupplierInformationReducer,
    getAllSupplierInformationReducer: getAllSupplierInformationReducer,
    getSupplierInformationByIdReducer: getSupplierInformationByIdReducer,
    createGroupOfSupplierReducer: createGroupOfSupplierReducer,
    updateGroupOfSupplierReducer: updateGroupOfSupplierReducer,
    getAllGroupOfSupplierReducer: getAllGroupOfSupplierReducer,
    getGroupOfSupplierByIdReducer: getGroupOfSupplierByIdReducer,
    getAllProductPriceReducer: getAllProductPriceReducer,
    getProductPriceByIdReducer: getProductPriceByIdReducer,
    createNewPurchaseReqReducer: createNewPurchaseReqReducer,
    updateNewPurchaseReqReducer: updateNewPurchaseReqReducer,
    getAllNewPurchaseReqReducer: getAllNewPurchaseReqReducer,
    getNewPurchaseReqByIdReducer: getNewPurchaseReqByIdReducer,
    genNewPurchaseReqDocNumberReducer: genNewPurchaseReqDocNumberReducer,
    createNewPurchaseOrderReducer: createNewPurchaseOrderReducer,
    updateNewPurchaseOrderReducer: updateNewPurchaseOrderReducer,
    getAllNewPurchaseOrderReducer: getAllNewPurchaseOrderReducer,
    getNewPurchaseOrderByIdReducer: getNewPurchaseOrderByIdReducer,
    genNewPurchaseOrderDocNumberReducer: genNewPurchaseOrderDocNumberReducer,
    getAllNewPoSplitReducer: getAllNewPoSplitReducer,
    getNewPoSplitByIdReducer: getNewPoSplitByIdReducer,
    genNewGrDocNumberReducer: genNewGrDocNumberReducer,
    createNewGrReducer: createNewGrReducer,
    getAllNewGrReducer: getAllNewGrReducer,
    getNewGrByIdReducer: getNewGrByIdReducer,
    updateNewGrReducer: updateNewGrReducer,
    getHQAddressByDateReducer: getHQAddressByDateReducer,
    createExpenseReducer: createExpenseReducer,
    updateExpenseReducer: updateExpenseReducer,
    getAllExpenseReducer: getAllExpenseReducer,
    getExpenseByIdReducer: getExpenseByIdReducer,
    genExpenseDocNumberReducer: genExpenseDocNumberReducer,
    getAllPartnerInfoReducer: getAllPartnerInfoReducer,
    getPartnerInfoByIdReducer: getPartnerInfoByIdReducer,
    updateStatusPartnerReducer: updateStatusPartnerReducer,
    getAllProvinceReducer: getAllProvinceReducer,
    getAddressCountriesReducer: getAddressCountriesReducer,
    getAddressProvinceReducer: getAddressProvinceReducer,
    getAddressDistrictReducer: getAddressDistrictReducer,
    getAddressSubdistrictReducer: getAddressSubdistrictReducer,
    getAddressLaoProvinceReducer: getAddressLaoProvinceReducer,
    getAddressLaoDistrictReducer: getAddressLaoDistrictReducer,
    getAddressLaoVillageReducer: getAddressLaoVillageReducer,
    getAllDistrictReducer: getAllDistrictReducer,
    getAllDistrictSubReducer: getAllDistrictSubReducer,
    getAllSubDistrictReducer: getAllSubDistrictReducer,
    getAllSubDistrictSubReducer: getAllSubDistrictSubReducer,
    getPartnerBankByIdReducer: getPartnerBankByIdReducer,
    getPartnerDocByIdReducer: getPartnerDocByIdReducer,
    getPartnerProductByIdReducer: getPartnerProductByIdReducer,
    getPartnerCommentByIdReducer: getPartnerCommentByIdReducer,
    createCommentPartnerReducer: createCommentPartnerReducer,
    updateStatusBankPartnerReducer: updateStatusBankPartnerReducer,
    updateStatusDocPartnerReducer: updateStatusDocPartnerReducer,
    getAllMstTypeDocumentReducer: getAllMstTypeDocumentReducer,
    getAllProductInfoReducer: getAllProductInfoReducer,
    getPresentationInfoByIdReducer: getPresentationInfoByIdReducer,
    updateStatusProductReducer: updateStatusProductReducer,
    getProductInfoByIdReducer: getProductInfoByIdReducer,
    getProductTypeReducer: getProductTypeReducer,
    getCategoryReducer: getCategoryReducer,
    getSubCategoryReducer: getSubCategoryReducer,
    createCommentProductReducer: createCommentProductReducer,
    getEvidenceTypeReducer: getEvidenceTypeReducer,
    getAllMstUnitReducer: getAllMstUnitReducer,
    getAllMstUnitWeightReducer: getAllMstUnitWeightReducer,
    getAllDimensionReducer: getAllDimensionReducer,
    getAllProductTypeFileReducer: getAllProductTypeFileReducer,
    getAllMstBrandReducer: getAllMstBrandReducer,
    // contract
    getAllDataContractReducer: getAllDataContractReducer,
    getAllDataContractExcelReducer: getAllDataContractExcelReducer,
    getAllMstBusinessReducer: getAllMstBusinessReducer,
    getContractBankByIdReducer: getContractBankByIdReducer,
    getContractProductInfoReducer: getContractProductInfoReducer,
    getAllBranchByPositionReducer: getAllBranchByPositionReducer,
    getAllBranchByAdPointReducer: getAllBranchByAdPointReducer,
    createContractNewReducer: createContractNewReducer,
    updateContractReducer: updateContractReducer,
    getContractByIdReducer: getContractByIdReducer,
    getContractProductByIdReducer: getContractProductByIdReducer,
    getContractPlacementByIdReducer: getContractPlacementByIdReducer,
    getContractAdsByIdReducer: getContractAdsByIdReducer,
    updateContractStatusReducer: updateContractStatusReducer,
    uploadContractFileDocReducer: uploadContractFileDocReducer,
    updateApproveFileReducer: updateApproveFileReducer,
    getContractFileByIdReducer: getContractFileByIdReducer,
    updateContractFileReducer: updateContractFileReducer,
    updateContractDelReducer: updateContractDelReducer,
    getContractBankInfoReducer: getContractBankInfoReducer,
    getContractBillingInfoReducer: getContractBillingInfoReducer,
    //quotation
    getAllDataQuotationReducer: getAllDataQuotationReducer,
    getAllDataQuotationExcelReducer: getAllDataQuotationExcelReducer,
    updateQuotationDelReducer: updateQuotationDelReducer,
    createQuotationReducer: createQuotationReducer,
    updateQuotationReducer: updateQuotationReducer,
    updateQuotationFileReducer: updateQuotationFileReducer,
    getQuotationNewByIdReducer: getQuotationNewByIdReducer,
    getQuotationFileByIdReducer: getQuotationFileByIdReducer,
    getQuotationDetailByIdReducer: getQuotationDetailByIdReducer,
    updateQuotationStatusReducer: updateQuotationStatusReducer,
    getQuotContractInfoByIdReducer: getQuotContractInfoByIdReducer,
    // bill
    billingReducer: billingReducer,
    getBillingByIDReducer: getBillingByIDReducer,
    createBillingReducer: createBillingReducer,
    updateBillingReducer: updateBillingReducer,
    uploadBillingReducer: uploadBillingReducer,
    billingQuotationListReducer: billingQuotationListReducer,
    getQuotationByIDReducer: getQuotationByIDReducer,
    // invoice
    invoiceReducer: invoiceReducer,
    getInvoiceByIDReducer: getInvoiceByIDReducer,
    createInvoiceReducer: createInvoiceReducer,
    updateInvoiceReducer: updateInvoiceReducer,
    uploadInvoiceReducer: uploadInvoiceReducer,
    createbybillingReducer: createbybillingReducer,
    // report
    getAllReportPurchaseProductPoItemReducer: getAllReportPurchaseProductPoItemReducer,
    getAllReportPurchaseSupplierReducer: getAllReportPurchaseSupplierReducer,
    getAllReportPurchaseOrderReducer: getAllReportPurchaseOrderReducer,
    getAllReportReceiveProductGrItemReducer: getAllReportReceiveProductGrItemReducer,
    getAllMapsReducer: getAllMapsReducer,
    getAllAppointmentReducer: getAllAppointmentReducer,
    //setting
    allBranchReducer: allBranchReducer,
    allBranchByIDReducer: allBranchByIDReducer,
    createBranchReducer: createBranchReducer,
    updateBranchReducer: updateBranchReducer,
    deleteBranchReducer: deleteBranchReducer,
    allPositionReducer: allPositionReducer,
    createPositionReducer: createPositionReducer,
    updatePositionReducer: updatePositionReducer,
    deletePositionReducer: deletePositionReducer,
    allAdpointReducer: allAdpointReducer,
    createAdpointReducer: createAdpointReducer,
    updateAdpointReducer: updateAdpointReducer,
    deleteAdpointReducer: deleteAdpointReducer,
    mstPromoTypeReducer: mstPromoTypeReducer,
    allPromotionReducer: allPromotionReducer,
    allPromotionByIDReducer: allPromotionByIDReducer,
    createPromotionReducer: createPromotionReducer,
    updatePromotionReducer: updatePromotionReducer,
    deletePromotionReducer: deletePromotionReducer,
    allBrandReducer: allBrandReducer,
    createBrandReducer: createBrandReducer,
    updateBrandReducer: updateBrandReducer,
    deleteBrandReducer: deleteBrandReducer,
    updateBillingCancelReducer: updateBillingCancelReducer,
    updateInvoiceCancelReducer: updateInvoiceCancelReducer,
    mstSysRoleReducer: mstSysRoleReducer,
    allSetUserReducer: allSetUserReducer,
    createSetUserReducer: createSetUserReducer,
    updateSetUserReducer: updateSetUserReducer,
    allSetUserByIDReducer: allSetUserByIDReducer,
    getAllMstTypeProductReducer: getAllMstTypeProductReducer,
    createMstTypeProductReducer: createMstTypeProductReducer,
    updateMstTypeProductReducer: updateMstTypeProductReducer,
    deleteMstTypeProductReducer: deleteMstTypeProductReducer,
    getAllMstCateProductReducer: getAllMstCateProductReducer,
    createMstCateProductReducer: createMstCateProductReducer,
    updateMstCateProductReducer: updateMstCateProductReducer,
    deleteMstCateProductReducer: deleteMstCateProductReducer,
    getAllMstSubCateProductReducer: getAllMstSubCateProductReducer,
    createMstSubCateProductReducer: createMstSubCateProductReducer,
    updateMstSubCateProductReducer: updateMstSubCateProductReducer,
    deleteMstSubCateProductReducer: deleteMstSubCateProductReducer,
    getDataclbookOneReducer: getDataclbookOneReducer,
    getDataclbookReducer: getDataclbookReducer,
    createclbookReducer: createclbookReducer,
    updateclbookReducer: updateclbookReducer,
    updateStatusclbookReducer: updateStatusclbookReducer,
    deleteclbookReducer: deleteclbookReducer,
    copyclbookReducer: copyclbookReducer,
    allCatalogReducer: allCatalogReducer,
    getProductReducer: getProductReducer,
    getCatalogByIdReducer: getCatalogByIdReducer,
    updateStatusCatalogReducer: updateStatusCatalogReducer,
    updateStatusNewReducer: updateStatusNewReducer,
    updateStatusRecomReducer: updateStatusRecomReducer,
    getPromotionReducer: getPromotionReducer,
    createCatalogReducer: createCatalogReducer,
    updateCatalogReducer: updateCatalogReducer,
    deleteCatalogReducer: deleteCatalogReducer,
    deleteOpenCatalogReducer: deleteOpenCatalogReducer,
    updateDetailCatalogReducer: updateDetailCatalogReducer,
    getDataShopReducer: getDataShopReducer,
    getDataShopBranchReducer: getDataShopBranchReducer,
    createShopReducer: createShopReducer,
    updateShopReducer: updateShopReducer,
    updateStatusShopReducer: updateStatusShopReducer,
    uploadShopReducer: uploadShopReducer,
    deleteShopReducer: deleteShopReducer,
    getSaleuserReducer: getSaleuserReducer,
    updateStatusShBranchReducer: updateStatusShBranchReducer,
    updateShBranchReducer: updateShBranchReducer,
    createShBranchReducer: createShBranchReducer,
    deleteShBranchReducer: deleteShBranchReducer,
    getDataShopBranchByIdReducer: getDataShopBranchByIdReducer,
    getDataShopByIdReducer: getDataShopByIdReducer,
    shopSpecialPriceReducer: shopSpecialPriceReducer,
    //reservation
    getAllDataRsreserveReducer: getAllDataRsreserveReducer,
    updateStatusSalesReducer: updateStatusSalesReducer,
    updateStatusReserveReducer: updateStatusReserveReducer,
    getDataRsreserveByIdReducer: getDataRsreserveByIdReducer,
    getDataCatalogByIdReducer: getDataCatalogByIdReducer,
    updateRsreserveReducer: updateRsreserveReducer,
    deleteRsreserveReducer: deleteRsreserveReducer,
    getDataAllCatalogReducer: getDataAllCatalogReducer,
    createRsreserveReducer: createRsreserveReducer,
    createReservationReducer: createReservationReducer,
    getReservationCreateShopReducer: getReservationCreateShopReducer,
    datalistProductReducer: datalistProductReducer,
    uploadProductReducer: uploadProductReducer,
    getProductDetailReducer: getProductDetailReducer,
    getAllChannelOfflineReducer: getAllChannelOfflineReducer,
    getAllChannelOnlineReducer: getAllChannelOnlineReducer,
    getAllProductFileTypeReducer: getAllProductFileTypeReducer,
    updateProductReducer: updateProductReducer,
    allShopReducer: allShopReducer,
    allShopBranchReducer: allShopBranchReducer,
    getDataVisitReducer: getDataVisitReducer,
    getShopReducer: getShopReducer,
    getObjectiveReducer: getObjectiveReducer,
    createVisitReducer: createVisitReducer,
    updateStatusVisitReducer: updateStatusVisitReducer,
    updateVisitReducer: updateVisitReducer,
    detailVisitReducer: detailVisitReducer,
    uploadVisitReducer: uploadVisitReducer,
    getMstBrandCateReducer: getMstBrandCateReducer,
    getReportBrandReducer: getReportBrandReducer,
    getReportProductReducer: getReportProductReducer,
    getReportSaleskuReducer: getReportSaleskuReducer,
    getReportSaleShopReducer: getReportSaleShopReducer,
    getReportSaleShopDetailReducer: getReportSaleShopDetailReducer,
    getReportChartPartnerReducer: getReportChartPartnerReducer,
    getReportChartBranchReducer: getReportChartBranchReducer,
    getReportChartBranchDayReducer: getReportChartBranchDayReducer,
    getReportChartSkuReducer: getReportChartSkuReducer,
    getReportBrandDetailReducer: getReportBrandDetailReducer,
    getReportChartReserveReducer: getReportChartReserveReducer,
    getDataVisitTotalReducer: getDataVisitTotalReducer,
    getReportSaleSkuListsoldReducer: getReportSaleSkuListsoldReducer,
    getReportSaleSkuListsnewReducer: getReportSaleSkuListsnewReducer,
    getReportChartReserveDayReducer: getReportChartReserveDayReducer,
    getReportChartSkuDayReducer: getReportChartSkuDayReducer,
    getReportChartPartnerDayReducer: getReportChartPartnerDayReducer,
    getReportSaleVisitAndReserveReducer: getReportSaleVisitAndReserveReducer,
    getReportSaleVisitAndReserveBySaleReducer: getReportSaleVisitAndReserveBySaleReducer,
    updateRsreserveStockReducer: updateRsreserveStockReducer,
    getCatalogSummaryReducer: getCatalogSummaryReducer,
    getReportSaleIntendantBranchReducer: getReportSaleIntendantBranchReducer,
    getReportBrandallReducer: getReportBrandallReducer,
    getReportBrandallSummaryReducer: getReportBrandallSummaryReducer,
    getReportVisitSaleMonthReducer: getReportVisitSaleMonthReducer,
    getReportVisitSaleMonthListReducer: getReportVisitSaleMonthListReducer,
    getReportReserveProductSummaryReducer: getReportReserveProductSummaryReducer,
    getReportReservationPerformanceMonthlyReducer: getReportReservationPerformanceMonthlyReducer,
    getReportReservationWorkTrackingReducer: getReportReservationWorkTrackingReducer,
    getReportSkuActualDeliveryMonthlyReducer: getReportSkuActualDeliveryMonthlyReducer,
    getReportProductNotReadyDeliveryDatalistReducer: getReportProductNotReadyDeliveryDatalistReducer,
    getReportProductNotReadyDeliveryWidgetReducer: getReportProductNotReadyDeliveryWidgetReducer,
    getReportShippingCostAuditReducer: getReportShippingCostAuditReducer,
    getReportPurchasePendingConfirmReducer: getReportPurchasePendingConfirmReducer,
    updateStatusContinueReducer: updateStatusContinueReducer,
    getPermissionReducer: getPermissionReducer,
    deletePermissionReducer: deletePermissionReducer,
    getPermissionMenusReducer: getPermissionMenusReducer,
    getPermissionDetailReducer: getPermissionDetailReducer,
    createPermissionReducer: createPermissionReducer,
    updatePermissionReducer: updatePermissionReducer,
    updatePermissionStatusReducer: updatePermissionStatusReducer,
    // import invoice
    getAllImportInvoiceMtReducer: getAllImportInvoiceMtReducer,
    uploadImportFileInvMtReducer: uploadImportFileInvMtReducer,
    confirmImportInvMtReducer: confirmImportInvMtReducer,
    getAllImportInvoiceTtReducer: getAllImportInvoiceTtReducer,
    uploadImportFileInvTtReducer: uploadImportFileInvTtReducer,
    confirmImportInvTtReducer: confirmImportInvTtReducer,
    // import product
    getAllImportProductMtReducer: getAllImportProductMtReducer,
    uploadFileProductMtReducer: uploadFileProductMtReducer,
    confirmProductMtReducer: confirmProductMtReducer,
    getAllImportProductTtReducer: getAllImportProductTtReducer,
    uploadFileProductTtReducer: uploadFileProductTtReducer,
    confirmProductTtReducer: confirmProductTtReducer,
    // report invoice
    getAllReportInvoiceMtReducer: getAllReportInvoiceMtReducer,
    getAllReportInvoiceTtReducer: getAllReportInvoiceTtReducer,
    // report product
    getAllReportProductMtReducer: getAllReportProductMtReducer,
    getAllReportProductTtReducer: getAllReportProductTtReducer
});
var rootReducer = function(state, action) {
    if (action.type === "USER_LOGOUT") {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
